module.exports = __webpack_public_path__ + "img/ps-25.7e88da9a.jpg";